import { Component, NgModule, NgZone, OnInit, ViewChild, Directive, Input, Inject, AfterViewInit, OnChanges } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { VisitEventType, VisitFilterType,  VisitSelectionEvent } from './model/model.class';
import { BrowserModule } from "@angular/platform-browser";
import { AgmCoreModule, MapsAPILoader, GoogleMapsAPIWrapper } from '@agm/core';
import { DirectionsMapDirective } from './map.directive';
import { SharedService } from "./shared.service";
import { TourPlan, User, Route, ShowCode, UserFeatures } from './model/model.class';
import { Labels } from './model/language.model.class';
import { ConfigService } from './service/config.service';
import { BarComponent } from './bar.component';

declare var google: any;

@Component({
  selector: 'map-app',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css'],
  providers: [GoogleMapsAPIWrapper, ConfigService]
})

export class MapComponent implements OnInit, AfterViewInit {
  @Input() accounId: string;
  @Input() user: User;
  @Input() labels: Labels;
  @Input() mapNumber: string;  
  @ViewChild(DirectionsMapDirective) vc: DirectionsMapDirective;
  tourPlan: TourPlan;
  showCodeValue: number;
  showCode = ShowCode;
  route: Route;
  center: any;
  zoomLevel: number;
  isUserChecked: boolean;
  isReportsChecked: boolean;
  isOneShotChecked: boolean;
  mapViewEnabled: boolean;
  objLoaderStatus: boolean;
  sidebarVisible: boolean = true;
  mapBarVisible = true;
  gmap: google.maps.Map;

  selectedVisitOptions: VisitEventType[] = [];

  zoomControlOptions: any = {
    position: 'TOP_RIGHT' 
  };

  public userFeatures;

  barsVisible: boolean = true;


  constructor(
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private gmapsApi: GoogleMapsAPIWrapper,
    private sharedService: SharedService/*,
    private _configService: ConfigService*/
  )
  {

    this.sharedService.tourPlanEvent.subscribe(data => {
      if (this.mapNumber == data.mapNumber) {
        this.tourPlan = data.tourPlan;
      }
    });

    this.sharedService.userEvent.subscribe(data => {
      this.user = data;
    });

    this.objLoaderStatus = false;

    this.userFeatures = [];
  }
  
  ngOnInit() {

    this.sharedService.barsVisible$.subscribe(visible => {
      this.mapBarVisible = visible;
    });


    this.sharedService.loaderStatus.subscribe((val: boolean) => {
      this.objLoaderStatus = val;
    });

    this.sharedService.visitFilterOptionsSource.subscribe(filters => {
      const f = filters.find(f => f.key === VisitFilterType.ShowUserPosition.toString());
      this.isUserChecked = f ? f.selected : false;
    });

    this.zoomLevel = 3;
    this.showCodeValue = 0;

    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.mapViewEnabled = false;

    if(currentUser && currentUser.userTypes && currentUser.userTypes.length > 0) {

      this.userFeatures = this.sharedService.getTextualFunctionality(currentUser);

      if(currentUser.userTypes.includes(UserFeatures.TrackingObserver))
        this.sharedService.SetVisibleUserPosition();

      if(currentUser.userTypes.includes(UserFeatures.MapView))
        this.mapViewEnabled = true;
    }
    this.isReportsChecked = false;
    this.isOneShotChecked = true;
    this.center = { lat: 51, lng: 6 };
    this.showCodeValue = (this.isUserChecked ? this.showCode.user : 0) + (this.isReportsChecked ? this.showCode.reports : 0) + (this.isOneShotChecked ? this.showCode.oneShot : 0);
  }

  ngAfterViewInit() {
    this.setupPlaceChangedListener();
  }

  onRouteChange(message: Route): void {
    this.route = message;
    this.sharedService.setMarkers(message, this.mapNumber);
    this.centerMarkers();
  }


  onMapReady(map: google.maps.Map) {
    this.gmap = map;

    this.gmap.setOptions({
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.TOP_RIGHT
      },
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false
    });
  }

  centerMarkers() {
    let markers: google.maps.Marker[] = this.route.dailyMeetingMarkers;

    if (!this.gmap || markers.length === 0) return;

    const bounds = new google.maps.LatLngBounds();
    markers.forEach(marker => bounds.extend(marker.getPosition()));

    google.maps.event.trigger(this.gmap, 'resize');

    this.gmap.fitBounds(bounds);

    setTimeout(() => {
      const center = this.gmap.getCenter();
      const newCenter = new google.maps.LatLng(center.lat(), center.lng()); // per spostarla devo aggiungere ad 0.5  : ad esemppio center.lng() + 0.5
      this.gmap.setCenter(newCenter);
    }, 100);
  }




  ShowMarkers(): void {

    this.showCodeValue = (this.isUserChecked ? this.showCode.user : 0) + (this.isReportsChecked ? this.showCode.reports : 0) + (this.isOneShotChecked ? this.showCode.oneShot : 0);
   
    if (this.route != undefined) {
      this.route.userMarkers.forEach(m => m.setVisible((this.showCodeValue & this.showCode.user) == this.showCode.user));

      if(this.tourPlan && this.tourPlan.PlanOfDay && this.tourPlan.PlanOfDay.Customers) {
        let customers = this.tourPlan.PlanOfDay.Customers;
        if (customers.length > 0) {
          if (customers.filter(c => c.Type == 1).length > 0) {
            this.route.recurringMarkers.forEach(m => {
              if(m['outcome'] != "") {
                var iconUrl = m.getIcon().toString().split("|");
                var bgColor = m['outcome'] == true && (this.showCodeValue & this.showCode.reports) == this.showCode.reports ? this.sharedService.getColorVisitOutcome(m['outcomeId']) : m['outcomeBG'];
                m.setIcon(this.sharedService.getMarkerIcon({ background: bgColor, eventType: m['eventType'], origin: m['origin'] }));
              }
            });
          }
          if (customers.filter(c => c.Type == 2 || c.Type == 3).length > 0) {
            this.route.oneShotMarkers.forEach(m => {
              if(m['outcome'] != "") {
                var iconUrl = m.getIcon().toString().split("|");
                var bgColor = m['outcome'] == true && (this.showCodeValue & this.showCode.reports) == this.showCode.reports ? this.sharedService.getColorVisitOutcome(m['outcomeId']) : m['outcomeBG'];
                m.setIcon(this.sharedService.getMarkerIcon({ background: bgColor, eventType: m['eventType'], origin: m['origin'] }));
              }
              m.setVisible((this.showCodeValue & this.showCode.oneShot) == this.showCode.oneShot);
            });
          }
        }
      }
    }
  }

  private OpenTab(tabView) {
    this.sharedService.SwitchTab(tabView);
  }

  private setupPlaceChangedListener() {
    this.ngZone.run(() => {
      if (this.vc && this.vc.directionsDisplay === undefined) {
        this.mapsAPILoader.load().then(() => {
          this.vc.directionsDisplay = new google.maps.DirectionsRenderer({
            suppressMarkers: true
          });
        });
      }
    });
  }

  onVisitFilterChanged(event: VisitSelectionEvent) {
    this.selectedVisitOptions = event.allOptions.filter(o => o.selected);

    const lastChanged = event.lastChanged;

    if (this.vc && this.vc.onVisitFilterChanged) {
      this.vc.onVisitFilterChanged(event);
    }
  }

  onVendorButtonClicked(mapNumber) {
    if (mapNumber==1)
      this.sharedService.isVendorPopupVisible = !this.sharedService.isVendorPopupVisible;
  }

  onTestCenterMapPointButtonClicked() {
    this.centerMarkers();
  }
    
}



// WEBPACK FOOTER //
// ./src/app/map.component.ts